import { el } from 'redom';

class ToggleInput {

  constructor(options) {

    this.el = el('.customers-filter-text-input-main', []);

  }

  handleValueChangeEvent(value, status) {

    this.onChange(status);

  }

  focus() {

  }

  setValue(value) {

    this.input.update({
      value
    });

  }

}

export default ToggleInput;